<mat-icon
  [svgIcon]="name"
  [style.fontSize.px]="size"
  [style.color]="color"
  aria-hidden="true"
/>